<template>
  <task-management></task-management>
</template>

<script>
import TaskManagement from "../components/task/TaskManagement.vue";
export default {
  components: { TaskManagement },
  name: "Task",
};
</script>

<style>
</style>